import { get, round, set, unset, pickBy } from "lodash-es"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import { getId } from "utils/custom.utils"
import { useMemo } from "react"
// REDUX Actions
export const SCHEDULING_TOGGLE_SELECT = "SCHEDULING_TOGGLE_SELECT"
export const SCHEDULING_TOGGLE_SELECT_ALL = "SCHEDULING_TOGGLE_SELECT_ALL"
export const SCHEDULING_CHANGE_DATE = "SCHEDULING_CHANGE_DATE"
export const TOGGLE_EDITABLE = "TOGGLE_EDITABLE"
export const REMOVE_EDITABLE = "REMOVE_EDITABLE"
export const HANDLE_SELECTOR_CHANGE = "HANDLE_SELECTOR_CHANGE"
export const VEHICLE_SELECT = "VEHICLE_SELECT"
export const SKU_TYPE_SELECT = "SKU_TYPE_SELECT"
export const CHANGE_SKU_COUNT = "CHANGE_SKU_COUNT"
export const DELETE_SCHEDULES = "DELETE_SCHEDULES"
export const CLEAR_SELECTED_SCHEDULES = "CLEAR_SELECTED_SCHEDULES"
export const SCHEDULING_CHANGE_FILTER = "SCHEDULING_CHANGE_FILTER"
export const SCHEDULING_CLEAR_FILTER = "SCHEDULING_CLEAR_FILTER"
export const CHANGE_SEARCH_QUERY = "CHANGE_SEARCH_QUERY"
export const CHANGE_NEW_VEHCILE = "CHANGE_NEW_VEHCILE"
export const CHANGE_NEW_DEPOT = "CHANGE_NEW_DEPOT"
// CHANGE PAGINATION
export const INCREMENT_PAGE = "INCREMENT_PAGE"
export const DECREMENT_PAGE = "DECREMENT_PAGE"
export const SCHEDULING_CHANGE_PAGE = "SCHEDULING_CHANGE_PAGE"
export const SCHEDULE_ADD_SUCCESSFUL = "SCHEDULE_ADD_SUCCESSFUL"
// INITIAL STATE
const INITIAL_STATE = {
  selectedDate: dayjs().format("YYYY-MM-DD"),
  query: "",
  filter: {},
  selectedSchedules: {},
  editableSchedules: {},
  companies: [],
  selectAll: false,
  page: 0,
  newVehicle: {},
  newDepot: {},
}

// Scheduling Reducer Function
function schedulingRedux(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case SCHEDULING_TOGGLE_SELECT:
      const selectedSchedules = { ...state.selectedSchedules }
      if (selectedSchedules[payload.id]) {
        unset(selectedSchedules, payload.id)
      } else {
        set(selectedSchedules, payload.id, {
          gatePass: payload.gatePass,
          isNotified: payload.isNotified,
        })
      }
      return {
        ...state,
        selectedSchedules,
        selectAll: false,
      }

    case SCHEDULING_TOGGLE_SELECT_ALL:
      if (state.selectAll) {
        return {
          ...state,
          selectedSchedules: {},
          selectAll: false,
        }
      } else {
        const selectedCopy = { ...state.selectedSchedules }
        payload.forEach(s =>
          set(selectedCopy, s.id, {
            gatePass: s.gatePass,
            isNotified: s.isNotified,
          })
        )
        return {
          ...state,
          selectedSchedules: selectedCopy,
          selectAll: true,
        }
      }
    case SCHEDULING_CHANGE_DATE:
      return {
        ...state,
        selectedDate: dayjs(payload).format("YYYY-MM-DD"),
        selectedSchedules: {},
        selectAll: false,
      }
    case TOGGLE_EDITABLE:
      return {
        ...state,
        editableSchedules: {
          ...state.editableSchedules,
          [payload.rowId]: payload,
        },
      }

    case HANDLE_SELECTOR_CHANGE:
      return {
        ...state,
        editableSchedules: {
          ...state.editableSchedules,
          [payload.scheduleId]: {
            ...state.editableSchedules[payload.scheduleId],
            [payload.type]: payload.item,
          },
        },
      }

    case VEHICLE_SELECT:
      const uomType = get(payload, "item.vehicleType.capacityUnit", undefined)
      const uomCount = get(payload, "item.vehicleType.capacity", undefined)

      const skuType = payload.preferredSku ? payload.preferredSku : undefined
      const prefUom = skuType && skuType.id ? skuType.capacityUnit : undefined

      const reqQty =
        getId(uomType) === getId(prefUom)
          ? Math.ceil(uomCount / skuType.capacity)
          : undefined

      return {
        ...state,
        editableSchedules: {
          ...state.editableSchedules,
          [payload.scheduleId]: {
            ...state.editableSchedules[payload.scheduleId],
            [payload.type]: payload.item,
            farmWeight: get(payload, "item.vehicleType.capacity", undefined),
            ...(uomType && { farmQuantityUnit: uomType }),
            ...(skuType && { skuType }),
            ...(reqQty && { requiredQuantity: reqQty }),
          },
        },
      }

    case SKU_TYPE_SELECT:
      const skuCount = get(
        state,
        ["editableSchedules", payload.scheduleId, "requiredQuantity"],
        0
      )
      return {
        ...state,
        editableSchedules: {
          ...state.editableSchedules,
          [payload.scheduleId]: {
            ...state.editableSchedules[payload.scheduleId],
            skuType: payload.item,
            farmQuantityUnit: get(payload, "item.capacityUnit", {}),
            farmWeight: payload.item && payload.item.capacity * skuCount,
          },
        },
      }
    case CHANGE_SKU_COUNT:
      const sku = get(
        state,
        ["editableSchedules", payload.scheduleId, "skuType"],
        null
      )
      const skuCapacity = sku.capacity

      const farmWeight = round(skuCapacity * payload.item, 2)
      return {
        ...state,
        editableSchedules: {
          ...state.editableSchedules,
          [payload.scheduleId]: {
            ...state.editableSchedules[payload.scheduleId],
            requiredQuantity: payload.item,
            farmWeight: farmWeight || farmWeight === 0 ? farmWeight : undefined,
            farmQuantityUnit:
              sku.capacityUnit && sku.capacityUnit.id
                ? sku.capacityUnit
                : undefined,
          },
        },
      }
    case REMOVE_EDITABLE:
      const es = { ...state.editableSchedules }
      unset(es, payload)
      return {
        ...state,
        editableSchedules: es,
      }

    case DELETE_SCHEDULES:
      const es1 = { ...state.editableSchedules }
      payload.forEach(p => unset(es1, p))
      return {
        ...state,
        editableSchedules: es1,
        selectedSchedules: {},
        selectAll: false,
      }
    case CLEAR_SELECTED_SCHEDULES:
      return {
        ...state,
        selectedSchedules: {},
        selectAll: false,
      }

    case SCHEDULING_CHANGE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...payload,
        },
        selectedSchedules: {},
        selectAll: false,
      }

    case SCHEDULING_CLEAR_FILTER:
      return {
        ...state,
        filter: {},
        selectedSchedules: {},
        selectAll: false,
      }
    case CHANGE_SEARCH_QUERY:
      return {
        ...state,
        query: payload,
        page: 0,
        filter: {},
      }
    case CHANGE_NEW_VEHCILE:
      return {
        ...state,
        newVehicle: payload,
      }
    case CHANGE_NEW_DEPOT:
      return {
        ...state,
        newDepot: payload,
      }

    case INCREMENT_PAGE:
      return {
        ...state,
        page: state.page + 1,
      }
    case SCHEDULING_CHANGE_PAGE:
      return {
        ...state,
        page: payload,
      }
    case DECREMENT_PAGE:
      return {
        ...state,
        page: state.page > 1 ? state.page - 1 : 1,
      }
    case SCHEDULE_ADD_SUCCESSFUL:
      return {
        ...state,
        page: 0,
        query: "",
        filter: {},
      }
    default:
      return state
  }
}

// Hooks

export function useSchedulingVariables() {
  const date = useSelector((state: any) => state.scheduling.selectedDate)
  const filter = useSelector((state: any) => state.scheduling.filter)
  const query = useSelector((state: any) => state.scheduling.query)
  const page = useSelector((state: any) => state.scheduling.page)
  const parsedFilter = useMemo(() => {
    return pickBy(
      {
        scheduledBy: filter.scheduledBy?.map(sb => getId(sb)),
        supplierType: filter?.supplierType?.id ?? null,
        isTripGenerated: filter?.isTripGenerated ?? null,
      },
      s => s || s === false || s === true
    )
  }, [filter])
  return {
    date,
    query,
    filter: parsedFilter,
    first: 10,
    skip: page * 10,
  }
}
export default schedulingRedux
